import { fetcher, REQUEST_URLS } from '@/endpoints/fionaMainApi';
import { PaginatedResult } from '@/types/paginatedResult.interface';
import { PostConfiguration } from '@/types/userProperty.interface';
import useSWR from 'swr';

type FetchMyPropertiesParams = {
  pagination: {
    currentPage: number;
    itemsPerPage: number;
  };
  accountPropertyId?: string | null;
  search?: string;
};

export const useMyPropertiesSearchName = (queryParams: FetchMyPropertiesParams) => {
  const { pagination, accountPropertyId, search } = queryParams;
  const queryFilterAccountPropertyId = accountPropertyId
    ? `&filter.id=$eq:${accountPropertyId}`
    : '';
  const myProperties = useSWR<PaginatedResult<PostConfiguration>>(
    REQUEST_URLS.FETCH_MY_PROPERTIES_CONFIGS({
      pagination,
      filterByAccountPropertyId: queryFilterAccountPropertyId,
      search,
    }),
    fetcher,
  );
  return myProperties;
};
